// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:28
import { AgencySpecificEvent_abstract } from './../../abstract/SagaBase/Objects/AgencySpecificEvent_abstract';
export class AgencySpecificEvent extends AgencySpecificEvent_abstract {}
